<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-08 10:41:00
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-08 10:47:25
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\complete.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
    <div class='complete'>
        <img src="../../assets/complete-01.png" alt="">
        <div>恭喜您，完成注册</div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    },
};
</script>

<style scoped lang="scss">
.complete {
    font-size: 16px;
    color: #333333;
    text-align: center;

    img {
        width: 173px;
        height: 100px;
        margin: 150px auto 20px;
    }
}
</style>
